export default __webpack_public_path__ + "032d51ae6750bad9de6c4c94387f2387.svg";